export enum PropertyListingCategory {
  SITE_SEARCH = "site_search",
  FILTERED = "filtered",
  CATEGORY_RENT = "category_rent",
  CATEGORY_BUY = "category_buy",
  CATEGORY_COMMERCIAL_RENT = "category_commercial_rent",
  CATEGORY_COMMERCIAL_BUY = "category_commercial_buy",
  CATEGORY_OFF_PLAN = "category_off_plan",
  SORTING_PRICE_LOW_TO_HIGH = "storing_price_low_to_high",
  SORTING_PRICE_HIGH_TO_LOW = "storing_price_high_to_low",
  SORTING_AREA_LOW_TO_HIGH = "storing_area_low_to_high",
  SORTING_AREA_HIGH_TO_LOW = "storing_area_high_to_low",
  SORTING_DATE_OLDEST_TO_NEWEST = "sorting_date_oldest_to_newest",
  SORTING_DATE_NEWEST_TO_OLDEST = "sorting_date_newest_to_oldest",
  PRODUCT_DETAIL_RECOMMENDED = "product_detail_recommended",
  MORTGAGE_DETAIL_RECOMMENDED = "mortgage_detail_recommended",
  AFFORDABILITY_DETAIL_RECOMMENDED = "affordability_detail_recommended",
  YALLA_VALUE_DETAIL_RECOMMENDED = "yalla_value_detail_recommended",
  FAVORITE = "favorites",
  PROPERTY_SHOWCASE = "property_showcase",
}

export enum PropertyListingSearchReferrer {
  DIRECT_LINK = "direct_link",
  HOMEPAGE = "homepage_filter",
}

export enum TriggerType {}
